import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_216: DocMigration = {
  maxSchemaVersion: "0.0.216",
  description: "Add new shutter setting or mark as legacy to handle new shutterWidthOverride functionality",
  apply(json: any) {
    function setLegacyShutter(setting: any) {
      if (!setting) {
        return;
      }
      if (setting.shutterType !== "DISABLED" && setting?.shutterWidthOverride === undefined) {
        setting.isLegacyWidthOverride = true;
      }
    }

    let shutterSettingsFound = false;
    // update settings
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "WINDOW_SHUTTER_SETTINGS") {
        setLegacyShutter(setting);
        shutterSettingsFound = true;
      }
    }

    if (!shutterSettingsFound) {
      // add setting with 0" width override
      const windowShutterSettingsSetId = uid();
      if (!json.settingsSets) {
        (json.settingsSets as any) = {};
      }

      (json.settingsSets[windowShutterSettingsSetId] as any) = {
        entityType: "SETTINGS_SET",
        name: "Window Shutter Settings Set",
        id: windowShutterSettingsSetId,
        sortIndex: 0,
      };

      // add Window Shutter Settings
      const newSettingsId = uid();
      (json.settings[newSettingsId] as any) = {
        ...{
          type: "WINDOW_SHUTTER_SETTINGS",
          shutterType: "SIMPLE_SLATS",
          midSlat: false,
          shutterWidthOverride: 0,
        },
        entityType: "SETTINGS",
        id: newSettingsId,
        parentId: windowShutterSettingsSetId,
        sortIndex: 0,
      };
    }

    return json;
  },
};

export default migration_0_0_216;
